export function useOpenSettings() {
  return () => {
    window.open(
      `chrome://settings/content/siteDetails?site=${encodeURIComponent(window.location.origin)}`,
      '_blank',
    )
  }
}
